import React from 'react'
import { NavLink } from 'react-router-dom'
import Header from '../../components/Header'
import Avatar from '../../components/Avatar'
import UserMenu from './UserMenu'
import Nav from '../../components/Nav'
import { mainLinks, checkoutLinks } from './constants'

import './Header.css'

class AppHeader extends React.Component {
  state = {
    menuIsOpen: false
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.closeMenu)
  }

  toggleMenu = event => {
    event.preventDefault()
    this.setState(
      prevState => ({
        menuIsOpen: !prevState.menuIsOpen
      }),
      () => {
        document.addEventListener('click', this.closeMenu)
      }
    )
  }

  closeMenu = () => {
    this.setState({ menuIsOpen: false }, () => {
      document.removeEventListener('click', this.closeMenu)
    })
  }

  getMenuItem = (option, i) => {
    const Component =
      option.component === 'a' ? (
        <a
          key={i}
          className="cookunity__nav_item cookunity__header_nav_item"
          href={option.pathname}
          target="_blank">
          <p className="label">
            {!!option.icon && (
              <img className="message_circle" src={option.icon} alt="icon" />
            )}
            {option.label}
            {option.new && <span className="new_tag">New</span>}
          </p>
        </a>
      ) : (
        <NavLink
          key={i}
          to={option.pathname}
          exact={option.exact}
          className="cookunity__nav_item cookunity__header_nav_item"
          activeClassName="selected">
          <p className="label">
            {!!option.icon && (
              <img className="message_circle" src={option.icon} alt="icon" />
            )}
            {option.label}
            {option.new && <span className="new_tag">New</span>}
          </p>
        </NavLink>
      )
    return Component
  }

  render() {
    const {
      location: { pathname: currentPath },
      userIsLoggedIn,
      userInitials,
      onGoBack,
      history
    } = this.props

    const { menuIsOpen } = this.state

    const links = currentPath === '/checkout' ? checkoutLinks : mainLinks
    const showAvatar = currentPath !== '/checkout'
    const withMenu = currentPath !== '/checkout'

    return (
      <div className="cookunity__header_container">
        <Header
          onGoBack={onGoBack}
          withMenu={withMenu}
          onLogoClick={() => history.push('/')}
          onToggleMenu={this.toggleMenu}
          onCloseMenu={this.closeMenu}
          navigation={
            <Nav className="cookunity__header_nav">
              {links.map((option, i) => this.getMenuItem(option, i))}
            </Nav>
          }
          avatar={
            showAvatar &&
            userIsLoggedIn && (
              <Avatar small initials={userInitials} onClick={this.toggleMenu} />
            )
          }
        />
        <UserMenu isOpen={menuIsOpen} onClose={this.closeMenu} />
      </div>
    )
  }
}

export default AppHeader



// WEBPACK FOOTER //
// ./src/modules/Header/Header.jsx